import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Layout from 'components/Layout/Layout';

class Info extends Component {

  render() {
    return (
      <div className='app-container'>
        <Layout history={this.props.history} option='info' />
      </div>
    );
  }
}

export default translate()(Info);
